export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="rounded-2xl overflow-hidden mb-10 max-w-2xl mx-auto aspect-[16/9]">
          <img
            src="https://readdy.ai/api/search-image?query=Stylish%20shopping%20bag%20with%20tissue%20paper%20on%20light%20oak%20table%20near%20sunny%20window%2C%20fresh%20morning%20vibe%2C%20lifestyle%20unboxing%20moment%2C%20warm%20natural%20light%2C%20clean%20modern%20interior%2C%20joyful%20purchase%20experience%2C%20editorial%20photography&width=1200&height=675&seq=cta-v2-hoobuy&orientation=landscape"
            alt="Hoobuy Spreadsheet - Comece agora"
            title="Encontre os melhores produtos na Hoobuy Spreadsheet"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
          Pronto para Encontrar os<br />
          <span className="italic text-foreground-500">Melhores Produtos?</span>
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto mb-8">
          Acesse agora a Hoobuy Spreadsheet mais completa em português e descubra sneakers, roupas e acessórios incríveis.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-foreground-950 text-white font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Hoobuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}